// extracted by mini-css-extract-plugin
export default {"tooltip":"fR-z","arrow":"gR-z"};